/* ==========================================================================
   Frank!y homepage — hero 'From farm to face' (prototype)
   Hoort bij sections/frankly-home-akker.liquid (markup, zie de kop daar) en
   assets/frankly-akker.css. Vraagt GSAP 3.13 met DrawSVGPlugin en
   MorphSVGPlugin (in de sectie, met defer, vóór dit bestand).

   Alle maten in wm (woordmerk-eenheden) van het scènevlak
   (viewBox -20 -110 703.862 292.69), alle tijden in seconden. Eén timeline
   per hero met labels:
     stil 0 · opbouw 0,3 · oogst 2,2 · opzuigen 3,0 · morph 4,3 ·
     claims 5,0 · letters 5,6.
   Het verhaal: het woord is de grond van een abstracte akker van stippen in
   merkkleuren (boom op de a, aloë op de n, akkers erachter), die zich opbouwt
   en dan bijna een seconde stil staat, zodat het oog hem leest. Dan de oogst:
   de vrucht valt op de r en spat in pitjes, een blad springt uit de aloë.
   Daarna zuigt de tube alles op als atomen en wordt hij het uitroepteken;
   alleen Frank!y blijft. De beek onder de letters en de twee druppels eruit
   zijn op 30-09 op verzoek van de eigenaar vervallen.

   DE STIPPEN (canvas .fh-atomen): elke stip heeft een thuis; hij komt op
   (groeit, rijst 8 wm of springt vanuit de vrucht), blijft staan, en vertrekt
   als het zuiggat (.fh-zuiggat, groeit vanaf de mond van de tube) hem
   bereikt: via een kwadratische boog (eerst omhoog, dan de mond in),
   versnellend. Buren vertrekken samen, dus het leest als banen. Onder de
   letters en de tube liggen nooit stippen. Het losse blad wordt bij het
   opzuigen ook stippen in merkkleur. Alles is een functie van de tijd van de
   timeline.

   BREED VLAK: vanaf 750 px staat het beeld over de hele schermbreedte en is
   de svg breder dan de viewBox; het woord blijft in het midden (xMidYMid
   meet). Het script leest de omrekening van wm naar canvas-px uit de CTM van
   de letters, tekent de akkerrijen door tot de randen en laat het zuiggat
   zoveel sneller groeien dat de verste stip even laat vertrekt als op een
   telefoon. De morph op M0 blijft dus vrij.

   Zonder GSAP, bij minder beweging: niets doen; de markup is de eindstand.
   QA: ?fh_t=<ms> zet de hero stil op dat moment; window.fhAkker.zet(t).
   ========================================================================== */
(function () {
  'use strict';

  var MERK = {
    teal: '#00A19C', tealBleek: '#7FD1C7', mint: '#96E2C0', berry: '#83245F',
    roze: '#E89CDB', zand: '#D9C9AE', taupe: '#8A7A5E'
  };

  function start(hero) {
    if (!hero || hero.hasAttribute('data-frankly-akker-actief')) return;
    hero.setAttribute('data-frankly-akker-actief', '');

    // Verminder beweging (prefers-reduced-motion) slaat de hero niet meer over:
    // dan speelt rustigSpelen() hieronder, met alleen overvloeiers (01-10).
    var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!window.gsap || !window.DrawSVGPlugin || !window.MorphSVGPlugin) {
      hero.classList.remove('is-wacht');
      return;
    }
    var gsap = window.gsap;
    gsap.registerPlugin(window.DrawSVGPlugin, window.MorphSVGPlugin);

    function alles(sel) {
      return Array.prototype.slice.call(hero.querySelectorAll(sel));
    }
    function een(sel) {
      return hero.querySelector(sel);
    }

    /* ---- Tijden en plekken (wm) ---------------------------------------- */
    var OOGST = 2.2;          // na bijna een seconde stilstaan
    var T0 = 3.0;             // het opzuigen begint
    var V = 950;              // snelheid van de rand van het zuiggat, wm/s
    var DVER = 571;           // verste stip op een telefoon, wm van de mond
    var RMAX = 650;           // straal waarbij alles weg is (telefoon)
    var M0 = 4.3;             // begin van de morph
    var MOND = [524, -4];     // de mond van de tube
    var S = [194, -14];       // waar de vrucht hangt (in de kroon)
    var S0 = 0.54;            // en hoe groot (deel van 48 wm)
    var L = [152, 28];        // waar hij op de r landt en uiteenspat

    /* ---- Elementen ----------------------------------------------------- */
    var svg = een('.fh-scene');
    var vak = een('.fh-frankly');
    var doek = een('.fh-atomen');
    if (!svg || !vak || !doek || !doek.getContext) {
      hero.classList.remove('is-wacht');
      return;
    }
    var heel = een('.fh-heel');
    var blad = een('.fh-blad');
    var excl = een('.fh-scene__excl');
    var buik = een('.fh-tube__buik');
    var tubeFoto = een('.fh-tube__foto');
    var naad = een('.fh-tube__naad');
    var lijf = een('.fh-tube__lijf');
    var dop = een('.fh-tube__dop');
    var letterK = een('.fh-scene__k');
    var letterY = een('.fh-scene__y');
    var zuiggat = een('.fh-zuiggat');
    var grond = een('.fh-scene__letters');
    var streepjes = alles('.fh-lijn--streep');
    var krak = alles('.fh-lijn--krak');
    var claims = alles('.fh-hero__claim');
    var letters = alles('.fh-letter');
    var kopje = een('.fh-hero2__kopje');
    var lucht = een('.fh-lucht');
    var gloed = een('.fh-gloed');

    // CSS-px per wm. Op een breed vlak is de svg breder dan de viewBox; de
    // CTM van de letters geeft dan de echte schaal.
    function schaalNu() {
      var c = grond && grond.getCTM();
      return c && c.a > 0 ? c.a : svg.getBoundingClientRect().width / 703.862;
    }
    // Lijndikte 1,4 px, omgerekend naar wm van het huidige vlak.
    function zetLijndikte() {
      var schaal = schaalNu();
      if (schaal > 0) svg.style.setProperty('--fh-lijn-dikte', (1.4 / schaal).toFixed(2));
    }
    zetLijndikte();

    /* ---- Beginstand ------------------------------------------------------ */
    // De markup is de eindstand (Frank!y). Hier: de tube terug, het teken weg.
    var lijfEind = lijf.getAttribute('d');
    var dopEind = dop.getAttribute('d');
    lijf.setAttribute('d', lijf.getAttribute('data-begin'));
    dop.setAttribute('d', dop.getAttribute('data-begin'));
    var lijnen = streepjes.concat(krak);
    gsap.set(heel, { autoAlpha: 1, scale: 0, transformOrigin: '50% 50%' });
    gsap.set(blad, { autoAlpha: 0, scale: 0.3, rotation: -30, transformOrigin: '20% 80%' });
    gsap.set(excl, { svgOrigin: '524.44 130' });
    gsap.set(buik, { svgOrigin: '524.44 130' });
    gsap.set(tubeFoto, { autoAlpha: 1 });
    gsap.set([lijf, dop], { opacity: 0 });
    gsap.set(dop, { transformOrigin: '50% 50%' });
    gsap.set(naad, { opacity: 0 });
    gsap.set(letterK, { x: -10 });
    gsap.set(letterY, { x: 10 });
    gsap.set(lijnen, { autoAlpha: 0, drawSVG: '0%' });
    gsap.set(claims, { opacity: 0, y: 6 });
    gsap.set(letters, { opacity: 0 });
    if (kopje) gsap.set(kopje, { opacity: 0 });
    if (lucht) gsap.set(lucht, { opacity: 0 });
    if (gloed) gsap.set(gloed, { opacity: 0, scale: 0.7, svgOrigin: '524.4 30' });
    gsap.set(zuiggat, { attr: { r: 0 } });

    /* ---- De timeline ----------------------------------------------------- */
    var tl = gsap.timeline({ paused: true, defaults: { ease: 'power2.out' } });
    tl.addLabel('stil', 0)
      .addLabel('opbouw', 0.3)
      .addLabel('oogst', OOGST)
      .addLabel('opzuigen', T0)
      .addLabel('morph', M0)
      .addLabel('claims', M0 + 0.7)
      .addLabel('letters', M0 + 1.3);

    function teken(lijn, t, duur) {
      tl.set(lijn, { autoAlpha: 1, drawSVG: '0%' }, t);
      tl.to(lijn, { drawSVG: '100%', duration: duur, ease: 'none' }, t);
    }
    function weg(lijn, t) {
      tl.to(lijn, { autoAlpha: 0, duration: 0.08, ease: 'none' }, t);
    }

    if (kopje) tl.to(kopje, { opacity: 1, duration: 0.3, ease: 'none' }, 0.2);

    // De lucht boven de akker licht op met de opbouw en dooft half als de akker
    // wordt opgezogen; de rest blijft als zachte gloed boven het woord staan.
    if (lucht) {
      tl.to(lucht, { opacity: 1, duration: 0.9, ease: 'power1.out' }, 0.3);
      tl.to(lucht, { opacity: 0.45, duration: 0.8, ease: 'power1.inOut' }, T0 + 0.1);
    }

    // De vrucht rijpt met de andere vruchten mee (de akker zelf is canvas).
    tl.to(heel, { scale: S0, duration: 0.22, ease: 'back.out(2.2)' }, 1.12);

    // Oogst: de vrucht wiebelt, valt op de r en spat uiteen (de pitjes zijn
    // canvas-stippen); het blad springt uit de aloë.
    var O = OOGST;
    tl.to(heel, { rotation: 12, duration: 0.05, ease: 'power1.out' }, O);
    tl.to(heel, { rotation: -9, duration: 0.06, ease: 'power1.inOut' }, O + 0.05);
    tl.to(heel, { rotation: 0, duration: 0.05, ease: 'power1.in' }, O + 0.11);
    tl.to(heel, { x: L[0] - S[0], duration: 0.28, ease: 'power1.out' }, O + 0.14);
    tl.to(heel, { y: L[1] - S[1], duration: 0.28, ease: 'power2.in' }, O + 0.14);
    streepjes.forEach(function (lijn, n) {
      teken(lijn, O + 0.28 + n * 0.02, 0.1);
      weg(lijn, O + 0.46 + n * 0.02);
    });
    tl.to(heel, { scaleX: S0 * 1.14, scaleY: S0 * 0.8, duration: 0.05, ease: 'power1.out' }, O + 0.42);
    tl.to(heel, { autoAlpha: 0, duration: 0.06, ease: 'none' }, O + 0.47);
    tl.to(blad, { autoAlpha: 1, scale: 1, rotation: 0, duration: 0.2, ease: 'back.out(1.8)' }, O + 0.06);
    krak.forEach(function (lijn, n) {
      teken(lijn, O + 0.16 + n * 0.03, 0.1);
      weg(lijn, O + 0.4 + n * 0.03);
    });

    // Opzuigen: het zuiggat groeit vanaf de mond en verbergt het blad (de
    // straal zet tekenAtomen, want de snelheid hangt af van de breedte van het
    // vlak); de stippen stromen de tube in; de tube zwelt op en schiet op M0
    // terug.
    tl.to(buik, { scaleX: 1.09, scaleY: 0.985, duration: M0 - T0, ease: 'power1.in' }, T0);
    tl.to(buik, { scaleX: 1, scaleY: 1, duration: 0.16, ease: 'back.out(3)' }, M0);

    // De mond van de tube gloeit op terwijl de stippen erin stromen en dooft
    // bij de poef.
    if (gloed) {
      tl.to(gloed, { opacity: 1, scale: 1, duration: M0 - T0, ease: 'power1.in' }, T0);
      tl.to(gloed, { opacity: 0, scale: 1.15, duration: 0.4, ease: 'power2.out' }, M0 + 0.3);
    }

    // Morph: naad, k en y knijpen, poef, lijf en dop worden het teken.
    tl.set(naad, { opacity: 0.55 }, M0 + 0.04);
    tl.set(naad, { opacity: 0 }, M0 + 0.08);
    tl.set(naad, { opacity: 0.55 }, M0 + 0.12);
    tl.to(letterK, { x: 0, duration: 0.2, ease: 'back.out(1.7)' }, M0 + 0.1);
    tl.to(letterY, { x: 0, duration: 0.2, ease: 'back.out(1.7)' }, M0 + 0.1);
    tl.to(excl, { scaleX: 0.86, scaleY: 1.06, duration: 0.1, ease: 'power2.in' }, M0 + 0.25);
    tl.to(tubeFoto, { autoAlpha: 0, duration: 0.05, ease: 'none' }, M0 + 0.3);
    tl.to(naad, { opacity: 0, duration: 0.05, ease: 'none' }, M0 + 0.3);
    tl.to([lijf, dop], { opacity: 1, duration: 0.05, ease: 'none' }, M0 + 0.3);
    tl.to(excl, { scaleX: 1.07, scaleY: 0.96, duration: 0.1, ease: 'power2.out' }, M0 + 0.35);
    tl.to(excl, { scaleX: 1, scaleY: 1, duration: 0.1, ease: 'power1.inOut' }, M0 + 0.45);
    tl.to(lijf, { morphSVG: lijfEind, duration: 0.35, ease: 'power2.out' }, M0 + 0.35);
    tl.to(dop, { morphSVG: dopEind, duration: 0.28, ease: 'power2.out' }, M0 + 0.4);
    tl.to(dop, { y: -58, rotation: 200, duration: 0.24, ease: 'power2.out' }, M0 + 0.4);
    tl.to(dop, { y: 0, rotation: 360, duration: 0.21, ease: 'power2.in' }, M0 + 0.64);
    tl.to(dop, { y: -8, duration: 0.05, ease: 'power1.out' }, M0 + 0.85);
    tl.to(dop, { y: 0, duration: 0.05, ease: 'power1.in' }, M0 + 0.9);
    tl.to(excl, { scaleX: 1.05, scaleY: 0.93, duration: 0.07, ease: 'power1.out' }, M0 + 0.85);
    tl.to(excl, { scaleX: 0.98, scaleY: 1.02, duration: 0.09, ease: 'power1.inOut' }, M0 + 0.92);
    tl.to(excl, { scaleX: 1, scaleY: 1, duration: 0.09, ease: 'power1.inOut' }, M0 + 1.01);

    // Claims vanaf M0 + 0,7, 250 ms na elkaar; onderschrift vanaf M0 + 1,3.
    tl.to(claims, { opacity: 1, y: 0, duration: 0.26, ease: 'power3.out', stagger: 0.25 }, M0 + 0.7);
    tl.to(letters, { opacity: 1, duration: 0.14, ease: 'none', stagger: 0.022 }, M0 + 1.3);

    hero.classList.add('is-gsap');

    /* ---- De stippen ------------------------------------------------------ */
    var pen = doek.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var AT = null;
    var tubeBeeld = null;
    var VZ = V;       // snelheid van het zuiggat op dit vlak (wm/s)
    var RZ = RMAX;    // en de straal waarop alles weg is
    var rLaatst = '';

    function plaatsDoek() {
      var fr = vak.getBoundingClientRect();
      var sr = svg.getBoundingClientRect();
      doek.style.left = (sr.left - fr.left) + 'px';
      doek.style.top = (sr.top - fr.top) + 'px';
      doek.style.width = sr.width + 'px';
      doek.style.height = sr.height + 'px';
      doek.width = Math.max(1, Math.round(sr.width * dpr));
      doek.height = Math.max(1, Math.round(sr.height * dpr));
    }

    function zetMatrix(ctx, el) {
      var c = el.getCTM();
      ctx.setTransform(c.a * dpr, c.b * dpr, c.c * dpr, c.d * dpr, c.e * dpr, c.f * dpr);
    }

    function dekking(el) {
      var o = 1;
      var n = el;
      while (n && n !== svg && n.nodeType === 1) {
        var cs = window.getComputedStyle(n);
        if (cs.visibility === 'hidden' || cs.display === 'none') return 0;
        o *= parseFloat(cs.opacity);
        n = n.parentNode;
      }
      return o;
    }

    function tekenVlak(ctx, el) {
      var vul = el.getAttribute('fill');
      if (!vul || vul === 'none' || vul.indexOf('url(') === 0) return;
      var o = dekking(el) * parseFloat(el.getAttribute('fill-opacity') || '1');
      if (o <= 0.01) return;
      zetMatrix(ctx, el);
      ctx.globalAlpha = o;
      ctx.fillStyle = vul;
      ctx.fill(new window.Path2D(el.getAttribute('d')));
    }

    // Een vast 'toevalsgetal' per positie, zodat het elke keer hetzelfde is.
    function hash(x, y) {
      var h = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
      return h - Math.floor(h);
    }

    // Kleur van een bronpixel naar de dichtstbijzijnde merkkleur.
    function naarMerk(r, g, b) {
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var l = (max + min) / 510;
      var sat = max === 0 ? 0 : (max - min) / max;
      if (sat < 0.14) return l < 0.5 ? MERK.taupe : MERK.zand;
      var hue;
      if (max === r) hue = ((g - b) / (max - min)) * 60;
      else if (max === g) hue = (2 + (b - r) / (max - min)) * 60;
      else hue = (4 + (r - g) / (max - min)) * 60;
      if (hue < 0) hue += 360;
      if (hue >= 165 && hue < 260) return l < 0.55 ? MERK.teal : MERK.tealBleek;
      if (hue >= 70 && hue < 165) return l < 0.5 ? MERK.teal : MERK.mint;
      if (hue >= 330 || hue < 15) return l < 0.5 ? MERK.berry : MERK.roze;
      if (hue >= 260 && hue < 330) return MERK.roze;
      return l < 0.5 ? MERK.taupe : MERK.zand;
    }

    // De abstracte akker, in wm. voeg(x, y, straal, kleur, dekking, opbouw,
    // opties). xmin..xmax is wat van het vlak te zien is: op een telefoon
    // -20..683,862, op een breed vlak meer (dan lopen de akkers door).
    function abstracteAkker(voeg, xmin, xmax) {
      var x;
      var y;
      var j;
      var breedte = Math.max(1, xmax - xmin);
      // 1. Akkers achter de gewassen: vijf rijen in perspectief tussen de
      //    horizon (y -58) en y -4; ver weg kleiner en lichter, in blokken van
      //    160 wm afwisselend mint en zand. De voorste rij komt eerst; de golf
      //    loopt in 0,25 s van links naar rechts over wat te zien is. Het
      //    raster blijft verankerd op x = -20, ook op een breder vlak.
      for (j = 0; j < 5; j++) {
        var f = j / 4;
        y = -58 + 54 * Math.pow(f, 1.4);
        var sx = 7 + 5 * f;
        var r = 1.0 + 1.2 * f;
        var x0 = -20 + (j % 2) * sx / 2;
        for (x = x0 - Math.floor((x0 - xmin) / sx + 1e-6) * sx; x <= xmax + 0.2; x += sx) {
          var blok = Math.floor((x + 20) / 160);
          voeg(x, y, r, (blok + j) % 2 ? 'zand' : 'mint', 0.6 + 0.4 * f, 0.3 + 0.25 * ((x - xmin) / breedte) + 0.15 * (1 - f));
        }
      }
      // 2. De boom op de a: stam, twee takjes, een kroon in een
      //    zonnebloemspiraal (gulden hoek) en vijf vruchten.
      var bx = 225;
      var by = -30;
      var R = 45;
      for (y = 37; y >= by + R * 0.5; y -= 4) {
        voeg(bx + Math.sin(y * 0.09) * 1.2, y, 2.4, 'taupe', 1, 0.5 + 0.2 * ((37 - y) / 60));
      }
      for (j = 1; j <= 4; j++) {
        voeg(bx - j * 4.2, -2 - j * 3.4, 1.9, 'taupe', 1, 0.62 + j * 0.02);
        voeg(bx + j * 4.2, 2 - j * 3.4, 1.9, 'taupe', 1, 0.64 + j * 0.02);
      }
      var n = 96;
      for (j = 0; j < n; j++) {
        var rr = R * Math.sqrt((j + 0.5) / n);
        var th = j * 2.39996323;
        voeg(bx + rr * Math.cos(th), by + rr * Math.sin(th) * 0.86, 2.8, j % 4 === 0 ? 'mint' : 'teal', 1, 0.65 + 0.45 * (j / n));
      }
      [[206, -50], [248, -44], [228, -20], [252, -12], [210, -30]].forEach(function (v, i) {
        voeg(v[0], v[1], 4.8, 'berry', 1, 1.08 + i * 0.03);
      });
      // 3. De aloë op de n: een waaier van zeven stippenlijnen vanuit (331, 40);
      //    de punten wiegen zachtjes.
      var hoeken = [-150, -128, -108, -90, -72, -55, -36];
      var lengtes = [72, 94, 106, 112, 104, 96, 74];
      hoeken.forEach(function (h, s) {
        var a = h * Math.PI / 180;
        var L2 = lengtes[s];
        for (var dd = 7; dd <= L2; dd += 5.2) {
          var ff = dd / L2;
          var buig = Math.sin(ff * Math.PI) * 4 * (s < 3 ? -1 : s > 3 ? 1 : 0);
          voeg(331 + Math.cos(a) * dd + buig, 40 + Math.sin(a) * dd, 3.4 - 1.5 * ff, ff < 0.8 ? 'teal' : 'mint', 1, 0.6 + 0.4 * ff + s * 0.02, { zwaai: ff });
        }
      });
      // 4. De pitjes: springen als de vrucht op de r uiteenspat vanuit het
      //    midden van de vrucht naar een kransje eromheen.
      for (j = 0; j < 20; j++) {
        var hoek = j * 2.39996323 + 0.6;
        var afst = 9 + (j % 4) * 5;
        voeg(L[0] + Math.cos(hoek) * afst, L[1] - 7 + Math.sin(hoek) * afst * 0.75, 2.9 + (j % 2) * 1.0, j % 3 === 0 ? 'roze' : 'berry', 1, OOGST + 0.47 + j * 0.006, { ox: L[0], oy: L[1] });
      }
    }

    function bouwAtomen() {
      plaatsDoek();
      var W = doek.width;
      var H = doek.height;
      AT = null;
      if (W < 4 || H < 4) return;
      var nu = tl.time();
      tl.seek(T0, true);

      // Van wm naar canvas-px: de CTM van de letters (CSS-px binnen de svg)
      // maal dpr. Op een telefoon is dat k = W / 703,862 met x = -20 op de
      // linkerrand; op een breed vlak staat het woord in het midden.
      var c0 = grond.getCTM();
      if (!c0 || !(c0.a > 0)) {
        tl.seek(nu, true);
        return;
      }
      var k = c0.a * dpr;
      var tx = c0.e * dpr;
      var ty = c0.f * dpr;
      var xmin = -tx / k;
      var xmax = (W - tx) / k;
      var Mx = MOND[0] * k + tx;
      var My = MOND[1] * k + ty;
      // Hoogste punt dat een boog mag halen (wm, uit de CSS): op desktop is de
      // bovenste strook van de lucht weggeknipt.
      var luchtTop = parseFloat(window.getComputedStyle(hero).getPropertyValue('--fh-lucht-top'));
      if (isNaN(luchtTop)) luchtTop = -106;
      var Tp = luchtTop * k + ty;
      var lijst = [];

      // Masker: de letters (op hun stand van T0) en de tube als rechthoek.
      var mc = document.createElement('canvas');
      mc.width = W;
      mc.height = H;
      var m = mc.getContext('2d');
      m.fillStyle = '#000';
      alles('.fh-letter-pad').forEach(function (el) {
        zetMatrix(m, el);
        m.fill(new window.Path2D(el.getAttribute('d')));
      });
      m.setTransform(k, 0, 0, k, tx, ty);
      m.fillRect(500, -6, 48, 137);
      var md = m.getImageData(0, 0, W, H).data;
      function bedekt(px, py) {
        var x = Math.round(px);
        var y = Math.round(py);
        if (x < 0 || y < 0 || x >= W || y >= H) return false;
        return md[(y * W + x) * 4 + 3] >= 100;
      }

      // De vertrektijden (ta, ts) volgen hieronder, als de verste stip bekend is.
      function atoom(px, py, extra) {
        var xw = (px - tx) / k;
        var yw = (py - ty) / k;
        var d = Math.sqrt((xw - MOND[0]) * (xw - MOND[0]) + (yw - MOND[1]) * (yw - MOND[1]));
        // De boog hooguit 180 wm boven de mond, en nooit hoger dan Tp: het
        // hoogste punt van een kwadratische boog is (P0 P2 - C^2)/(P0 - 2C + P2);
        // daaruit volgt de hoogste toegestane C.
        var cyRuw = Math.min(py, My) - Math.min(30 + 0.25 * d, 180) * k;
        var cyMin = Tp - Math.sqrt(Math.max(0, py - Tp) * Math.max(0, My - Tp));
        lijst.push({
          x: px, y: py, d: d,
          cx: px + (Mx - px) * 0.35,
          cy: Math.max(cyRuw, cyMin),
          dur: 0.28 + 0.22 * Math.min(1, d / 600),
          r: extra.r, a: extra.a, kleur: extra.kleur,
          tb: extra.tb, fase: xw * 0.19,
          zwaai: extra.zwaai || 0,
          dx: extra.ox !== undefined ? extra.ox * k + tx - px : 0,
          dy: extra.oy !== undefined ? extra.oy * k + ty - py : 8 * k
        });
      }

      abstracteAkker(function (xw, yw, rw, kleur, a, tb, opties) {
        var px = xw * k + tx;
        var py = yw * k + ty;
        var r = rw * k;
        if (bedekt(px, py) || bedekt(px - r, py) || bedekt(px + r, py) || bedekt(px, py - r) || bedekt(px, py + r)) return;
        var o = opties || {};
        atoom(px, py, { r: r, a: a, kleur: MERK[kleur], tb: tb, zwaai: o.zwaai, ox: o.ox, oy: o.oy });
      }, xmin, xmax);

      // Het blad op zijn stand van T0 wordt ook stippen (merkkleur).
      var bc = document.createElement('canvas');
      bc.width = W;
      bc.height = H;
      var b = bc.getContext('2d');
      alles('.fh-scene__los path').forEach(function (el) {
        tekenVlak(b, el);
      });
      var bd = b.getImageData(0, 0, W, H).data;
      var stap = 3.2 * k;
      for (var y = stap / 2; y < H; y += stap) {
        for (var x = stap / 2; x < W; x += stap) {
          var px = Math.min(W - 1, Math.round(x));
          var py = Math.min(H - 1, Math.round(y));
          var i4 = (py * W + px) * 4;
          if (bd[i4 + 3] <= 20 || bedekt(px, py)) continue;
          atoom(px, py, { r: Math.max(0.9 * dpr, stap * 0.42), a: 1, kleur: naarMerk(bd[i4], bd[i4 + 1], bd[i4 + 2]) });
        }
      }
      tl.seek(nu, true);

      // Het zuiggat groeit zo snel dat de verste stip vertrekt op
      // T0 + DVER / V, net als op een telefoon; op een breed vlak dus sneller.
      var dmax = 0;
      lijst.forEach(function (p) { dmax = Math.max(dmax, p.d); });
      VZ = V * Math.max(1, dmax / DVER);
      RZ = Math.max(RMAX, dmax + 80);
      var eind = 0;
      lijst.forEach(function (p) {
        p.ta = T0 + p.d / VZ;
        p.ts = p.ta + 0.05 + hash(p.x + 0.5, p.y + 0.5) * 0.06;
        eind = Math.max(eind, p.ts + p.dur);
      });
      AT = { lijst: lijst, Mx: Mx, My: My, eind: eind, k: k, ty: ty };
    }

    function terugUit(u) {
      var c = 1.70158;
      var v = u - 1;
      return 1 + (c + 1) * v * v * v + c * v * v;
    }

    function tekenAtomen(t) {
      // Het zuiggat in het masker van het blad groeit even snel als de golf
      // van vertrekkende stippen.
      var rNu = Math.max(0, Math.min(RZ, (t - T0) * VZ)).toFixed(1);
      if (rNu !== rLaatst) {
        zuiggat.setAttribute('r', rNu);
        rLaatst = rNu;
      }
      pen.setTransform(1, 0, 0, 1, 0, 0);
      pen.clearRect(0, 0, doek.width, doek.height);
      if (!AT || t < 0.3 || t > AT.eind) return;
      var l = AT.lijst;
      var k = AT.k;
      var TWEE_PI = Math.PI * 2;
      for (var i = 0; i < l.length; i++) {
        var p = l[i];
        if (t < p.tb) continue;
        var x = p.x;
        var y = p.y;
        var st = p.r;
        var a = p.a;
        if (p.tb !== undefined) {
          var ub = (t - p.tb) / 0.35;
          if (ub < 1) {
            var eb = 1 - Math.pow(1 - ub, 3);
            st = p.r * Math.max(0, terugUit(ub));
            x = p.x + (1 - eb) * p.dx;
            y = p.y + (1 - eb) * p.dy;
          } else if (t < p.ts) {
            if (p.zwaai) x = p.x + Math.sin(t * 2.4 + p.fase * 0.3) * 1.6 * k * p.zwaai;
          }
        } else if (t < p.ta) {
          continue;
        }
        if (t >= p.ta) {
          var u = (t - p.ts) / p.dur;
          if (u >= 1) continue;
          if (u > 0) {
            var e = u * u;
            var r = 1 - e;
            x = r * r * p.x + 2 * r * e * p.cx + e * e * AT.Mx;
            y = r * r * p.y + 2 * r * e * p.cy + e * e * AT.My;
            st = p.r * (1 - 0.55 * e);
            if (u > 0.8) a *= (1 - u) / 0.2;
          }
        }
        if (st <= 0.05) continue;
        pen.globalAlpha = a;
        pen.fillStyle = p.kleur;
        pen.beginPath();
        pen.arc(x, y, st, 0, TWEE_PI);
        pen.fill();
      }
      pen.globalAlpha = 1;
      // De tube staat vóór de stippen die er van achteren langs omhoog gaan:
      // knip zijn silhouet uit, behalve de bovenste 12 wm (daar is de mond).
      if (tubeBeeld && tubeBeeld.naturalWidth && window.getComputedStyle(tubeFoto).visibility !== 'hidden') {
        pen.save();
        pen.beginPath();
        pen.rect(0, 8 * k + AT.ty, doek.width, doek.height);
        pen.clip();
        pen.globalCompositeOperation = 'destination-out';
        zetMatrix(pen, tubeFoto);
        var w = parseFloat(tubeFoto.getAttribute('width'));
        var h = parseFloat(tubeFoto.getAttribute('height'));
        var sch = Math.min(w / tubeBeeld.naturalWidth, h / tubeBeeld.naturalHeight);
        var iw = tubeBeeld.naturalWidth * sch;
        var ih = tubeBeeld.naturalHeight * sch;
        pen.drawImage(tubeBeeld, parseFloat(tubeFoto.getAttribute('x')) + (w - iw) / 2, parseFloat(tubeFoto.getAttribute('y')) + (h - ih) / 2, iw, ih);
        pen.restore();
        pen.setTransform(1, 0, 0, 1, 0, 0);
      }
    }

    tl.eventCallback('onUpdate', function () {
      tekenAtomen(tl.time());
    });

    function zet(t) {
      tl.pause(t);
      tekenAtomen(tl.time());
      return AT ? { stippen: AT.lijst.length, eind: Math.round(AT.eind * 1000) / 1000 } : null;
    }
    window.fhAkker = { tl: tl, zet: zet };

    var wachtOpMaat = null;
    window.addEventListener('resize', function () {
      zetLijndikte();
      window.clearTimeout(wachtOpMaat);
      wachtOpMaat = window.setTimeout(function () {
        if (!AT) return;
        bouwAtomen();
        tekenAtomen(tl.time());
      }, 150);
    });

    /* ---- Start ------------------------------------------------------------ */
    // Pas als de tube er is (voor het uitknippen) en de pagina zichtbaar is.
    var gestart = false;
    function speel() {
      if (gestart) return;
      gestart = true;
      var qa = parseFloat(new URLSearchParams(window.location.search).get('fh_t'));
      if (qa >= 0) {
        zet(qa / 1000);
        return;
      }
      if (rustig) return rustigSpelen();
      tl.play(0);
    }

    // Met 'Verminder beweging' aan: hetzelfde verhaal zonder dat er iets
    // verschuift. Geen vliegende stippen, geen vallende vrucht, geen knijpende
    // tube; alleen overvloeien, en dat staat die instelling toe. De akker zoals
    // hij er vlak voor de oogst bij staat vaagt in, blijft even staan, en vaagt
    // over in de eindstand (het woord met het uitroepteken).
    function rustigSpelen() {
      gsap.set(vak, { autoAlpha: 0 });
      zet(OOGST - 0.2);
      gsap.timeline()
        .to(vak, { autoAlpha: 1, duration: 0.8, ease: 'none' })
        .to(vak, { autoAlpha: 0, duration: 0.5, ease: 'none' }, '+=2.2')
        .add(function () { zet(tl.duration()); })
        .to(vak, { autoAlpha: 1, duration: 0.6, ease: 'none' });
    }
    function wanneerZichtbaar() {
      if (document.visibilityState !== 'hidden') return speel();
      document.addEventListener('visibilitychange', function wacht() {
        if (document.visibilityState === 'hidden') return;
        document.removeEventListener('visibilitychange', wacht);
        speel();
      });
    }
    var klaar = false;
    function beeldGeladen() {
      if (klaar) return;
      klaar = true;
      try {
        bouwAtomen();
      } catch (fout) {
        AT = null;
      }
      wanneerZichtbaar();
    }
    tubeBeeld = new Image();
    tubeBeeld.addEventListener('load', beeldGeladen, { once: true });
    tubeBeeld.addEventListener('error', beeldGeladen, { once: true });
    tubeBeeld.src = tubeFoto.getAttribute('href');
    window.setTimeout(beeldGeladen, 2500);
  }

  function alle() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-frankly-akker]'), start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target && e.target.querySelector ? e.target.querySelector('[data-frankly-akker]') : null;
    if (hero) start(hero);
  });
})();
